import React from 'react';
import Layout from '../Layout/Layout';
import JunoClientSnackbar from '../../client/Juno/client/components/global/JunoClientSnackbar';
import SavedBankAcountActions from '../components/savedBankAcounts/SavedBankAcountActions';

export default function AccountsPage() {
    return (
        <div className="bg-[#F4F4F5] dark:bg-[#18181B]">
            <SavedBankAcountActions />
            <JunoClientSnackbar />
        </div>
    );
}
